interface IPalette {
  name: string;
}

const availablePalettes: Array<IPalette> = [
  {
    name: 'palette-1'
  },
  {
    name: 'palette-1-dark'
  },
  {
    name: 'palette-2'
  },
  {
    name: 'palette-3'
  }
];

// select the default color palette
const defaultPalette: IPalette = availablePalettes.find((palette: IPalette) => {
  return palette.name === 'palette-1';
  // return palette.name === 'palette-2';
});

export { IPalette, availablePalettes, defaultPalette };
